import { collection, doc, type DocumentReference, type CollectionReference } from 'firebase/firestore';
import { db, FIREBASE_PATHS } from '../config/firebase';

// Get reference to user's application document
export const getApplicationRef = (userId: string): DocumentReference | null => {
  if (!db) {
    console.warn('Firebase Firestore not configured');
    return null;
  }
  return doc(db, FIREBASE_PATHS.applications, userId);
};

// Get collection reference for all applications
export const getApplicationsRef = (): CollectionReference | null => {
  if (!db) {
    console.warn('Firebase Firestore not configured');
    return null;
  }
  return collection(db, FIREBASE_PATHS.applications);
};